import React, { useEffect } from "react";
import Aos from "aos";
import { Helmet } from "react-helmet";

import Footer from "../shared/layout/Footer";
import Header from "../shared/layout/Header";
import Newsletter from "../components/Newsletter";
import logo from "../assets/image/prettywomen.png";

const Makeup = () => {
  useEffect(() => {
    Aos.init({ delay: 1000 });
  });
  const allservices = [
    { title: "MAKE-UP DU JOUR" },
    { title: "MAKE-UP DU SOIR" },
    { title: "MAKE-UP POUR LES MARIES" },
    { title: "LES CHIGNOUS" },
  ];
  const services = allservices.map((element) => {
    return (
      <div className="pricing-card-css col-lg-6 col-12 mt-4">
        <article className="d-flex align-items-center text-white">
          <h5>{element.title}</h5>
          <span className="pricing-card-line"></span>
          <figure>
            <img
              className="card-price-css"
              src={logo}
              alt="pretty women logo"
            />
          </figure>
        </article>
        {element.description ? <p>{element.description}</p> : null}
      </div>
    );
  });
  return (
    <>
      <Helmet>
        <meta name="description" content="pretty women make-up service" />
        <meta
          property="og:url"
          content="https://www.prettywomen.ma/services/make-up"
        />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="pretty women make-up" />
        <meta
          property="og:description"
          content="pretty women make-up service"
        />
        <meta property="og:image" content="" />
        <title>make-up service - Pretty women services</title>
      </Helmet>
      <Header />
      <main className="services-wrapper pt-5">
        <section className="container" data-aos="fade-right">
          <div className="text-center services-text d-flex flex-column align-items-center">
            <h1>Make up</h1>
            <p className="text-muted w-75">
              Nous offrons des services de maquillage pour différentes
              occasions, tels que le maquillage de jour, de soirée, pour les
              mariées, ainsi que des prestations de coiffure pour les chignons.
            </p>
          </div>
          <article className="service-back-img service-back-img-makeup d-flex flex-column  justify-content-center ps-5 text-white my-5"></article>
        </section>
        <section className="container py-5" data-aos="fade-right">
          <div className="row">{services}</div>
        </section>
        <Newsletter />
      </main>
      <Footer />
    </>
  );
};

export default Makeup;
